"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DeepLearningProjectIcon = function DeepLearningProjectIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("span", null, "icon variant does not exist!") : _react["default"].createElement("path", {
      d: "M5 12H1V6h4V5H1V3h13v2h-4v1h4v4h.695a2.27 2.27 0 0 1 .305.03V2h-4V0H4v2H0v11h5zM5 1h5v1H5zm8 13v-1h1v1zM9 7.329V6H6v3h1v3H6v3h3v-1h2v.696A1.305 1.305 0 0 0 12.305 16h2.39A1.305 1.305 0 0 0 16 14.695v-2.39A1.305 1.305 0 0 0 14.695 11h-2.024zM7 7h1v1H7zm0 7v-1h1v1zm7.695-2a.305.305 0 0 1 .305.305v2.39a.305.305 0 0 1-.305.305h-2.39a.305.305 0 0 1-.305-.305v-2.39a.305.305 0 0 1 .305-.305zm-3.16-.721A1.28 1.28 0 0 0 11 12.305V13H9v-1H8V9h1v-.257z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("span", null, "icon variant does not exist!") : _react["default"].createElement("path", {
      d: "M2 18.004V8h19v8.05a4.448 4.448 0 0 1 1 .226V3.004h-6v-2H7v2H1V19h8.345a3.504 3.504 0 0 1 .727-.996zM8 2h7v1.004H8zM2 4h19v3.004H2zm20 16.5a1.5 1.5 0 1 1-1.5-1.5 1.502 1.502 0 0 1 1.5 1.5zM18.99 14H18v1.293l-3.107-3.108A2.474 2.474 0 0 0 15 11.5a2.5 2.5 0 1 0-3 2.45v4.1A2.5 2.5 0 1 0 14.95 21h2.1a3.5 3.5 0 1 0 0-1h-2.1A2.502 2.502 0 0 0 13 18.05v-4.1a2.487 2.487 0 0 0 1.4-.843L17.293 16H16v.99h2.99zm1.51 4a2.5 2.5 0 1 1-2.5 2.5 2.502 2.502 0 0 1 2.5-2.5zM14 20.5a1.5 1.5 0 1 1-1.5-1.5 1.502 1.502 0 0 1 1.5 1.5zM12.5 13a1.5 1.5 0 1 1 1.5-1.5 1.502 1.502 0 0 1-1.5 1.5zm5.5 3"
    }));
  }

  if (size <= 32) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 32 32",
      className: classes
    }), filled ? _react["default"].createElement("span", null, "icon variant does not exist!") : _react["default"].createElement("path", {
      d: "M3 24V10h25v11.213a5.455 5.455 0 0 1 1 .394V4h-8V2H10v2H2v21h10.267a4.44 4.44 0 0 1 .511-1zm8-21h9v1h-9zM3 5h25v4H3zm23.5 17a4.485 4.485 0 0 0-4.45 4h-2.1A3.481 3.481 0 0 0 17 23.05v-4.1a3.472 3.472 0 0 0 2.107-1.136L22.293 21H21v1h3v-3h-1v1.293l-3.33-3.33A3.499 3.499 0 1 0 16 18.95v4.1A3.492 3.492 0 1 0 19.95 27h2.1a4.49 4.49 0 1 0 4.45-5zM14 15.5a2.5 2.5 0 1 1 2.5 2.5 2.503 2.503 0 0 1-2.5-2.5zM16.5 29a2.5 2.5 0 1 1 2.5-2.5 2.503 2.503 0 0 1-2.5 2.5zm10 1a3.5 3.5 0 1 1 3.5-3.5 3.504 3.504 0 0 1-3.5 3.5zm2.5-3.5a2.5 2.5 0 1 1-2.5-2.5 2.502 2.502 0 0 1 2.5 2.5z"
    }));
  }
};

var _default = DeepLearningProjectIcon;
exports["default"] = _default;